import { render, staticRenderFns } from "./UserPropertyList.vue?vue&type=template&id=8be40180"
import script from "./UserPropertyList.vue?vue&type=script&lang=js"
export * from "./UserPropertyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports